import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Company',
    value: 'newCC',
  },
  // {
  //   label: 'Company name',
  //   value: 'companyDetails[name]',
  // },
  {
    label: 'Address',
    value: 'address[state]',
  },
  // {
  //   label: 'Country',
  //   value: 'address[country]',
  // },
  // {
  //   label: 'Membership',
  //   value: 'membershipTire',
  // },
  // {
  //   label: 'end date',
  //   value: 'endDate',
  // },
  {
    label: 'Representative',
    value: 'name',
  },
  {
    label: 'Mobile',
    value: 'personalDetails[mobile]',
  },
  {
    label: 'Email',
    value: 'personalDetails[email]',
  },
  // {
  //   label: 'Logo',
  //   value: 'bussinessPermit',
  // },
  {
    action: ['edit', 'delete'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
